import { LoadingSpinnerPanel } from '@frontend/web-react/components/Primitives/Loading/LoadingSpinnerPanel';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { validateSsoCallbackSearch } from './-publicSearch';

const LazySSOCallback = lazy(() => import('./-sso-callback').then((module) => ({ default: module.SSOCallback })));

const SSOCallbackRouteComponent = () => (
  <Suspense fallback={<LoadingSpinnerPanel fullScreen />}>
    <LazySSOCallback />
  </Suspense>
);

export const Route = createFileRoute('/sso-callback')({
  component: SSOCallbackRouteComponent,
  validateSearch: validateSsoCallbackSearch,
});
